import { render, staticRenderFns } from "./SpecificIndicators.vue?vue&type=template&id=64617f2b"
import script from "./SpecificIndicators.vue?vue&type=script&lang=js"
export * from "./SpecificIndicators.vue?vue&type=script&lang=js"
import style0 from "./SpecificIndicators.vue?vue&type=style&index=0&id=64617f2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports